import { cn } from '@/lib/utils'
import { AnimatedHeading } from '@/components/generals/animated-heading'

interface SectionHeadingProps {
    eyebrow?: string
    title: string
    description?: string
    align?: 'left' | 'center'
    light?: boolean
    className?: string
    titleClassName?: string
}

export const Eyebrow = ({
    children,
    light,
    className
}: {
    children: string
    light?: boolean
    className?: string
}) => (
    <span
        className={cn(
            'inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.24em]',
            light ? 'text-gold-soft' : 'text-gold-deep',
            className
        )}
    >
        <span className={cn('h-px w-8', light ? 'bg-gold-soft/60' : 'bg-gold/60')} />
        {children}
    </span>
)

export const SectionHeading = ({
    eyebrow,
    title,
    description,
    align = 'left',
    light,
    className,
    titleClassName
}: SectionHeadingProps) => {
    const centered = align === 'center'

    return (
        <div
            className={cn(
                'flex flex-col gap-5',
                centered ? 'items-center text-center' : 'items-start',
                className
            )}
        >
            {eyebrow && <Eyebrow light={light}>{eyebrow}</Eyebrow>}

            <AnimatedHeading
                onScroll
                text={title}
                className={cn(
                    'max-w-3xl text-balance text-3xl sm:text-4xl md:text-5xl',
                    light ? 'text-parchment' : 'text-foreground',
                    titleClassName
                )}
            />

            {description && (
                <p
                    className={cn(
                        'max-w-2xl text-base leading-relaxed sm:text-lg',
                        light ? 'text-parchment/70' : 'text-muted-foreground'
                    )}
                >
                    {description}
                </p>
            )}
        </div>
    )
}
